module.exports = __webpack_public_path__ + "938ed879a6c005d30063e022bdc96a37.fbx";